export default __webpack_public_path__ + "static/media/8.15e2cb49.jpg";